export default __webpack_public_path__ + "media/images/dashboard_icons/photo_sharing-2094fe1b56c22ad54ff150a36d6159b1.svg";